// The live camera inside the kit's Scanner (CAT-C-06). Starts on mount, stops on unmount or on the first read.
// When the camera is missing or refused, says so: the sheet always offers typing the code.
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Notice, Scanner } from '../../design/kit';
import { startScan, type ScanSession } from '../../lib/scan';

export function CameraScan({ onCode }: { onCode: (code: string) => void }) {
  const { t } = useTranslation();
  const video = useRef<HTMLVideoElement>(null);
  const handler = useRef(onCode);
  handler.current = onCode;
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let session: ScanSession | undefined;
    let cancelled = false;
    if (video.current) {
      startScan(video.current, (code) => handler.current(code))
        .then((s) => {
          if (cancelled) s.stop();
          else session = s;
        })
        .catch(() => {
          if (!cancelled) setUnavailable(true);
        });
    }
    return () => {
      cancelled = true;
      session?.stop();
    };
  }, []);

  return (
    <>
      <Scanner hint={t('scan.hint')}>
        <video ref={video} muted playsInline aria-hidden="true" />
      </Scanner>
      {unavailable && <Notice tone="warning">{t('scan.nocamera')}</Notice>}
    </>
  );
}
